export default {
    appParams: {
        value: "Value",
        cancel: "Cancel",
        enterRoleName: "Enter role name",
    },
    dBase: {
        createBase: "Create base",
        bindExistingBase: "Bind an existing base",
        server: "Server",
        serverNotSelected: "No server selected",
        base: "Base",
        baseNotSelected: "Base is not selected",
        name: "Name",
        shortName: "Short name",
        alias: "Alias",
        comment: "Comment",
        baseType: "Base type",
        baseTypeNotSelected: "Base type not selected",
        cancel: "Cancel",
        enterBaseName: "Enter Database Name",
        enterServer: "Enter Server",
        enterBaseShortName: "Enter the short name of the database",
        enterBaseType: "Enter base type",
        enterBaseServer: "Enter Base Server",
        createError: "Error while creating, contact the developer",
    },
    form: {
        formName: "Form name",
        insert: "Add",
        edit: "Edit",
        server: "server",
        app: "application",
        dataBase: "database",
        appParam: "application parameter",
        user: "user",
        task: "task",
        role: "role"
    },
    param: {
        paramType: "Parameter type",
        value: "Value",
        paramTypeNotSelected: "Parameter type not selected",
        cancel: "Cancel",
        enterParamType: "Enter parameter type",
        enterParamValue: "Enter parameter value",
    },
    role: {
        value: "Value",
        specialUserChecked: "Special user",
        cancel: "Cancel",
        enterRoleName: "Enter Role Name",
    },
    section: {
        name: "Name",
        alias: "Alias",
        path: "Path",
        server: "Server",
        serverNotSelected: "No server selected",
        appType: "Application Type",
        appTypeNotSelected: "No application type selected",
        appBelongsWeb: "The application belongs to the Web",
        cancel: "Cancel",
        enterAppName: "Enter Application Name",
        enterAppPath: "Enter Application Path",
        enterAppServer: "Enter Application Server",
        enterAppType: "Enter Application Type",
    },
    server: {
        name: "Name",
        serverTypeNotSelected: "Server type not selected",
        serverType: "Server type",
        pathHttp: "The http path",
        host: "Host",
        path: "Path",
        cancel: "Cancel",
        enterServerName: "Enter server name",
        enterServerType: "Enter server type",
        enterServerPathUrl: "Enter the server http path",
        enterServerHost: "Enter server host",
        enterServerPath: "Enter server path",
    },
    task: {
        taskName: "Task name",
        path: "Path",
        taskType: "Task type",
        opportunityPickInPackage: "Possibility to build into a package",
        comment: "Comment",
        cancel: "Cancel",
        enterTaskName: "Enter task name",
        enterTaskPath: "Enter task path",
        enterTaskType: "Enter the task type",
    },
    user: {
        login: "Login",
        password: "Password",
        fullName: "Full name",
        expirationDate: "Expiration date",
        role: "Role",
        blockUser: "Block user",
        cancel: "Cancel",
        enterUserLogin: "Enter your username",
        enterUserFullName: "Enter the full username",
        enterEndDate: "Enter the expiration date",
        enterPassword: "Enter password",
        enterRole: "Enter Role",
    },
    errors: {
        notAllRequiredFieldsSelected: "Not all required fields are selected",
        nameHasSpace: "Should not have spaces",
    }
}